import CopyToClipboardDataField from "./CopyToClipboardDataField";
export default CopyToClipboardDataField;
